module.exports = __webpack_public_path__ + "components/flag/static/square/fi-ad03ce97a79d4a352298c6d6ad7a024a.svg";